//  import AboutSection from "../components/AboutSection";
import ServicesGrid from "../components/ServicesGrid";
import BlogList from "../components/BlogList";
import Testimonials from "../components/Testimonials";
import Footer from "../components/Footer";
import Sofa from "../components/ServiceRegions/İntros/Sofa";
import HeroSlider from "../components/HeroSlider";


const SofaWashing = () => {
  return (
    <> 
    <div>
        
      <HeroSlider />
      <Sofa/>
      <ServicesGrid />
      <BlogList/>
      <Testimonials/>
      <Footer/>
     
    </div>
     </>
  );
};

export default SofaWashing;